<template>
<transition name="fade">
  <section class="global-guide hi-df hi-aic hi-jcc">
    <section class="container hi-df hi-fdc">
      <section class="tips">
        <el-alert :title="$t('indexPage.global_guide_alert')" type="warning" simple show-icon></el-alert>
      </section>
      <section class="hi-f1 hi-df hi-fdc hi-overflow-hidden">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="item of guideList"
            :label="item.wizardTitle"
            :name="item.id"
            :key="item.id"
          >
          </el-tab-pane>
        </el-tabs>
        <section class="global-guide-customer hi-df hi-f1"
            v-for="item of guideList"
            v-if="item.id === activeName"
            :key="item.id">
            <el-scrollbar wrap-class="customer-left-wrapper">
              <ul v-for="(child,index) of item.wizardItemList" :key="child.id">
                <li class="left-wrapper-step">
                  <p :class="['title hi-text-overflow', activeChildGuide === index ?  'success' : '' ]" :title="child.name">{{child.name}}</p>
                  <div class="line" v-if="index !== item.wizardItemList.length - 1"></div>
                </li>
              </ul>
            </el-scrollbar>
          <section class="right-wrapper hi-df hi-fdc hi-f1">
            <section class="right-wrapper-header hi-df">
              <section class="hi-f1 hi-df">
                <label v-if="activeChildGuideInfo.requireDo" class="require-tip">*</label>
                <p class="guide-des" :title="activeChildGuideInfo.description">{{activeChildGuideInfo.description}}</p>
              </section>
              <section class="tools">
                <el-button v-show="activeChildGuide" @click="prewStep">{{$t('indexPage.prev')}}</el-button>
                <el-button v-show="activeChildGuide < activeChildLen - 1" @click="nextStep" :disabled="activeChildGuideInfo.requireDo">{{$t('indexPage.next')}}</el-button>
                <el-button type="primary" @click="$emit('close')" v-if="opFinished || !isSysGuide">{{$t('indexPage.abort_guide')}}</el-button>
                <el-button type="primary"
                  @click="submit"
                  v-show="item.wizardParentType === 'system'
                  && activeChildGuide === activeChildLen - 1
                  && !opFinished && isSysGuide"
                >{{$t('indexPage.complete_guide')}}</el-button>
              </section>
            </section>
            <iframe-warp :menu="activeChildGuideInfo" width="100%" class="hi-f1"></iframe-warp>
          </section>
        </section>
      </section>
    </section>
  </section>
</transition>
</template>
<script>
import API from 'api/common'
import iframeWarp from './global-guide-iframe.vue'
export default {
  data () {
    return {
      opFinished:false,
      activeName: '',
      activeIndex: 0,
      activeChildGuide: 0,
      // info: [],
      // sysInfo:[]
    }
  },
  components:{
    iframeWarp,
  },
  props: {
    guideList: Array,
    isSysGuide: Boolean
  },
  computed: {
    activeChildLen () {
      return this.guideList[this.activeIndex].wizardItemList.length
    },
    activeChildGuideInfo() {
      return this.guideList[this.activeIndex].wizardItemList[this.activeChildGuide]
    },
  },
  watch: {
    activeName () {
      this.activeChildGuide = 0
    },
    guideList(val){
      this.activeName = val[0].id
    },
  },
  methods: {
    handleClick (tab) {
      this.activeIndex = tab.index
    },
    nextStep () {
      this.activeChildGuide = this.activeChildGuide + 1
    },
    prewStep () {
      this.activeChildGuide = this.activeChildGuide - 1
    },
    submit(){
      const  {
        roleId,
        id:wizardId,
      } = this.guideList[0]
      const params ={
        roleId,
        wizardId,
      }
      API
      .updateGuideOperation(params)
      .then(res=>{
        this.$emit('close')
        this.opFinished = true;
        this.$message.success(this.$t('indexPage.system_complete_guide'))
      })
    },
    // getSysData(){
    //    API
    //   .getSysGuide()
    //   .then(res=>{
    //     let data = res.data || []
    //     if(data.length){
    //       this.opFinished = data[0].opFinished;
    //       if(!this.opFinished){
    //         this.$emit('open')
    //       }
    //       this.sysInfo = data.slice(0,1)
    //       this.info = data
    //       this.activeName = data[0].id
    //     }
    //   })
    // },
    // getAllData(){
    //   API
    //   .getGuideList()
    //   .then(res=>{
    //     let data = res.data || []
    //     if(data.length){
    //       this.info = data
    //       this.activeName = data[0].id
    //     }else{
    //       this.$emit('noGuide')
    //     }
    //   })
    // },
    getMessage(data){
      try{
        console.log(data)
        const message = JSON.parse(data.data);
        if(message.type != 'guide') return
        const {
          componentId,
          menuId,
        } = this.activeChildGuideInfo
        if(componentId === message.componentId && menuId === message.menuId){
          this.activeChildGuideInfo.requireDo = false
        }
      }catch(e){
        console.log(e)
      }

    }
  },
  created(){
    window.addEventListener('message',this.getMessage,false)
  },
  beforeDestroy(){
    window.removeEventListener('message',this.getMessage,false)
  }
}
</script>

<style lang="scss" scoped>
  .global-guide{
    position: absolute;
    top:0;
    bottom: 0;
    left:0;
    right: 0;
    z-index: 999;
    background: rgba(0,0,0,0.3);
    .tips{
      padding:4px
    }
    .container{
      width:90%;
      height:90%;
      background:#ffffff;
    }
    &-customer{
      padding:4px 8px;
      width:100%;
      height:100%;
      overflow: hidden;
      .left-wrapper{
        width:180px;
        padding-right:12px;
        border-right: 1px solid #e0e0e0;
        &-step{
          position: relative;
          text-align: center;
          .title{
            background: #ffffff;
            border:1px solid #e0e0e0;
            line-height: 40px;
            text-align: center;
            border-radius: 10px;
            padding:0 6px;
          }
          .title.success{
            background: #1E7FFF;
            color: #fff;
          }
          .line{
            display: inline-block;
            border-color: #e0a8a9;
            background-color: #ebebeb;
            height:60px;
            width: 1px;
            margin: 8px 0;
          }
        }
      }
      .right-wrapper{
        padding-left:12px;
        &-header{
          height:40px;
          border-bottom: 1px solid #e0e0e0;
          .guide-des{
            width: 600px;
            overflow:hidden;
            text-overflow:ellipsis;
            display:-webkit-box;
            -webkit-box-orient:vertical;
            -webkit-line-clamp:2;
          }
          .require-tip{
            margin-right:10px;
            color:#ff5000;
          }
        }
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

</style>

<style lang="scss">
.global-guide{
  .customer-left-wrapper{
    width:200px;
    height:100%;
    padding:0 12px;
    border-right: 1px solid #e0e0e0;
    overflow-x: hidden;
  }
}


</style>
